import { version } from '@instantdb/version';
export default version;
